import {getClientConfig} from 'ultra/configs/general';
import {post, get} from '../../../Helpers/http';

const {api} = getClientConfig(window)

export async function telegramOpen(bot, data) {
    if (data.init) {
        return post(`${api}/bot/${bot}/open`, data);
    }
    else {
        return new Promise(resolve => {
            console.error('Відсутній обєкт initData з Телеграму')
            resolve({})
        })
    }
}

// TODO: ? remove ?
export async function getTelegramLogedUser() {
    return get(`${api}/bot/user`).promise;
}

export function getTelegramUserNotifications(bot) {
    return get(`${api}/bot/${bot}/notifications`);
}

export function setTelegramUserNotifications(bot, data) {
    return post(`${api}/bot/${bot}/notifications`, data);
}
